import React from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);

  const navLinks = [
    {
      name: 'Overview',
      href: '#over',
      icon: 'https://slelguoygbfzlpylpxfs.supabase.co/storage/v1/object/public/test-clones/01094675-c23f-432c-b065-2c82ff5c3d40-india-sales-office-com/assets/svgs/overview-1.svg',
    },
    {
      name: 'Costing',
      href: '#floors',
      icon: 'https://slelguoygbfzlpylpxfs.supabase.co/storage/v1/object/public/test-clones/01094675-c23f-432c-b065-2c82ff5c3d40-india-sales-office-com/assets/svgs/overview-1.svg',
    },
    {
      name: 'Site Map & Floor Plan',
      href: '#floorss',
      icon: 'https://slelguoygbfzlpylpxfs.supabase.co/storage/v1/object/public/test-clones/01094675-c23f-432c-b065-2c82ff5c3d40-india-sales-office-com/assets/svgs/blueprint-2.svg',
    },
    {
      name: 'Amenities',
      href: '#ame',
      icon: 'https://slelguoygbfzlpylpxfs.supabase.co/storage/v1/object/public/test-clones/01094675-c23f-432c-b065-2c82ff5c3d40-india-sales-office-com/assets/svgs/amenities-3.svg',
    },
    {
      name: 'Location',
      href: '#looc',
      icon: 'https://slelguoygbfzlpylpxfs.supabase.co/storage/v1/object/public/test-clones/01094675-c23f-432c-b065-2c82ff5c3d40-india-sales-office-com/assets/svgs/location-4.svg',
    },
    {
      name: 'Virtual Tour',
      href: '#videos',
      icon: 'https://slelguoygbfzlpylpxfs.supabase.co/storage/v1/object/public/test-clones/01094675-c23f-432c-b065-2c82ff5c3d40-india-sales-office-com/assets/svgs/site-visit-5.svg',
    },
    {
      name: 'Brochure',
      href: '#',
      icon: 'https://slelguoygbfzlpylpxfs.supabase.co/storage/v1/object/public/test-clones/01094675-c23f-432c-b065-2c82ff5c3d40-india-sales-office-com/assets/svgs/bro-download-6.svg',
      isModal: true,
    },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-[1000] bg-[#f8f9fa] border-b border-[#dee2e6] h-[66px] flex items-center"
    >
        <div className="container mx-auto px-4 flex items-center justify-between">
          {/* Logo */}
          <a href="#" className="flex-shrink-0">
            <img
              src="https://slelguoygbfzlpylpxfs.supabase.co/storage/v1/object/public/test-clones/01094675-c23f-432c-b065-2c82ff5c3d40-india-sales-office-com/assets/images/logo-1.png"
              alt="Abhee Celestial City"
              width={190}
              height={50}
              className="h-[40px] md:h-auto w-auto"
            />
          </a>

          {/* Mobile Menu Toggle */}
          <button
            className="lg:hidden p-2 text-[#212529] border border-black/10 rounded focus:outline-none"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle navigation"
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>

          {/* Navigation */}
          <nav
            className={`${
              isMenuOpen ? 'flex' : 'hidden'
            } lg:flex absolute lg:relative top-[66px] lg:top-0 left-0 w-full lg:w-auto bg-white lg:bg-transparent flex-col lg:flex-row shadow-lg lg:shadow-none border-t lg:border-t-0 border-[#dee2e6] items-center z-[1100] transition-all duration-300 ease-in-out`}
          >
            <ul className="flex flex-col lg:flex-row items-center w-full lg:w-auto py-4 lg:py-0">
              {navLinks.map((link, index) => (
                <li key={index} className="w-full lg:w-auto group">
                  <a
                    href={link.href}
                    className={`flex items-center px-4 py-3 lg:py-2 text-[14.4px] font-medium transition-colors duration-200 whitespace-nowrap border-b lg:border-b-0 border-[#eee] lg:border-transparent ${
                      index === 0 
                        ? 'text-[#323992]' 
                        : 'text-[rgba(0,0,0,0.5)] hover:text-[rgba(0,0,0,0.7)]'
                    }`}
                    onClick={() => setIsMenuOpen(false)}
                  >
                    <img
                      src={link.icon}
                      alt={link.name}
                      className="w-[20px] h-[20px] mr-2"
                      style={{ filter: index === 0 ? 'none' : 'grayscale(1) opacity(0.5)' }}
                    />
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

      <style jsx global>{`
        .nav-link {
          font-family: 'Inter', sans-serif;
          color: rgba(0, 0, 0, 0.5);
        }
        .nav-link:hover {
          color: rgba(0, 0, 0, 0.7);
        }
        .nav-item.active .nav-link {
          color: #323992;
        }
        @media (max-width: 1023px) {
          nav {
            z-index: 1040;
          }
        }
      `}</style>
    </header>
  );
};

export default Header;